module.exports = __webpack_public_path__ + "img/case-logo-24.f32b482e.png";